import { Route, Routes } from "react-router-dom";

import { Routes as AdminRoutes } from "ui/modules/navigation";

import { ApplicationSettingsPage } from "../pages/ApplicationSettingsPage";

import { SettingRouterCmp } from "./types";

const SettingRouter: SettingRouterCmp = () => (
  <Routes>
    <Route path={ApplicationSettingsPage.route} element={<ApplicationSettingsPage />} />
  </Routes>
);

SettingRouter.route = AdminRoutes.ModuleRouter;

export default SettingRouter;
